import React, { useState, useEffect } from 'react';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import View from '../../../../assets/images/interview/view.svg';
import Delete from '../../../../assets/images/interview/delete.svg';
import Schedule from '../../../../assets/images/interview/schedule.svg';
import StatusModal from './statusModal';
import { useDispatch, useSelector, connect } from 'react-redux';
import { getScheduledInterviewData } from '../../../../actions/interview.action';
import Pagination from 'react-js-pagination';
import { ToastContainer, toast } from 'react-toastify';
import DeleteModal from '../../../confirmModal/Delete';
import request from '../../../../api/api';
import './index.scss';

const useStyles = makeStyles({
   table: {
      minWidth: 650,
      '& .MuiTableCell-head': {
         backgroundColor: '#EDF2F7',
         padding: '10px',
         fontSize: '12px',
         fontWeight: '500',
         color: '#718096',
         border: 'none',
         '&:first-child': {
            borderRadius: '10px 0 0 10px',
         },
         '&:last-child': {
            borderRadius: '0 10px 10px 0',
         },
      },
      '& .MuiTableCell-body': {
         border: 'none',
         padding: '10px',
         fontSize: '13px',
         fontWeight: '400',
         color: '#718096',
         '&.row_status_Completed': {
            color: ' #15B436',
         },
         '&.row_status_Booked': {
            color: '#FF8800',
         },
         '&.row_status_Cancelled': {
            color: '#DF0000',
         },
         '&.row_status_Confirmed': {
            color: '#007BFD',
         },
         '& .status_interview': {
            width: '8px',
            height: '8px',
            display: 'inline-block',
            borderRadius: '50%',
            position: 'relative',
            top: '-1px',
         },
         '& .status_Completed': {
            background: '#15B436',
         },
         '& .status_Booked': {
            background: '#FF8800',
         },
         '& .status_Cancelled': {
            background: '#DF0000',
         },
         '& .status_Confirmed': {
            background: '#007BFD',
         },
      },
   },
   head: {
      fontSize: '13px',
      margin: '0 0 2px',
   },
   subhead: {
      fontSize: '12px',
      margin: '0',
   },
   positions: {
      width: '145px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      margin: '0',
   },
   button: {
      background: 'transparent',
      border: 'none',
      padding: '0',
      minWidth: 'auto',
      margin: '0 5px',
   },
});

const ActionButtons = ({ data, onStatus, onDelete }) => {
   const classes = useStyles();
   return (
      <>
         {/* <Button className={classes.button}>
            <img src={View} />
         </Button> */}
         <Button className={classes.button} onClick={(e) => onDelete(e, data)}>
            <img src={Delete} />
         </Button>
         <Button className={classes.button} onClick={() => onStatus(data)}>
            <img src={Schedule} />
         </Button>
      </>
   );
};

const TableInterview = ({ getScheduledInterviewData }) => {
   const classes = useStyles();
   const dispatch = useDispatch();
   const [selectedData, setSelectedData] = useState(null);
   const [deleteData, setDeleteData] = useState(null);

   let { scheduled_interview_list, scheduled_interview_count, interview_status_toggle } = useSelector((state) => state.interviewReducer);
   const [interviewData, setInterviewData] = useState({ limit: 25, skip: 0, activePage: 1, totalCount: scheduled_interview_count || 0 });

   useEffect(() => {
      getScheduledInterviewData(interviewData);
   }, [interviewData.skip]);

   useEffect(() => {
      setInterviewData((prevData) => ({
         ...prevData,
         totalCount: scheduled_interview_count,
      }));
   }, [scheduled_interview_count]);

   const handleOnStatus = (data) => {
      setSelectedData(data);
      dispatch({ type: 'INTERVIEW_STATUS_TOGGLE', payload: !interview_status_toggle });
   };

   const statusObj = {
      0: 'Cancelled',
      1: 'Booked',
      2: 'Completed',
      3: 'Confirmed',
   };

   const handlePageChange = async (pageNumber) => {
      let skip = pageNumber * interviewData.limit - interviewData.limit;
      setInterviewData((prevData) => ({
         ...prevData,
         skip: skip ? skip : 0,
         activePage: pageNumber ? pageNumber : interviewData.activePage,
      }));
   };

   const handleOnDelete = (e = {}, data) => {
      setDeleteData({
         id: data._id,
         target: e.currentTarget,
      });
   };

   const handleOnDeleteConfirm = async (action, Id) => {
      if (action === 'yes') {
         const res = await request({
            url: '/candidate/interview/delete',
            method: 'POST',
            data: { Id },
         });
         setDeleteData(null);
         if (res.status === 1) {
            toast.success(res.response);
            getScheduledInterviewData();
         } else {
            toast.error(res.response);
         }
      } else {
         setDeleteData(null);
      }
   };

   return (
      <>
         <TableContainer className="table__container">
            <Table className={classes.table} aria-label="simple table">
               <TableHead>
                  <TableRow>
                     <TableCell align="center">SL NO</TableCell>
                     <TableCell>CANDIDATE NAME</TableCell>
                     <TableCell>SCHEDULE DATE & TIME</TableCell>
                     <TableCell>INTERVIEWER NAME</TableCell>
                     <TableCell>JOB POSITIONS</TableCell>
                     <TableCell>STATUS</TableCell>
                     <TableCell>ACTION</TableCell>
                  </TableRow>
               </TableHead>
               <TableBody>
                  {scheduled_interview_list && scheduled_interview_list.length > 0 ? (
                     scheduled_interview_list.map((item, i) => {
                        let candidate = item && item.candidateDetails ? item.candidateDetails : {};
                        let interview = item && item.interviewerDetails ? item.interviewerDetails : {};
                        let scheduleTime = item && item.interview_time ? item.interview_time : {};
                        return (
                           <TableRow key={item.slno}>
                              <TableCell component="th" scope="item" align="center">
                                 {i + 1}
                              </TableCell>
                              <TableCell>
                                 <h6 className={classes.head}>{candidate && `${candidate.name || ''} ${candidate.surname || ''}`}</h6>
                                 <p className={classes.subhead}>{candidate && candidate.email ? candidate.email : ''}</p>
                              </TableCell>
                              <TableCell>{scheduleTime && `${scheduleTime.date || ''} - ${scheduleTime.time || ''}`}</TableCell>
                              <TableCell>{interview && `${interview.name || ''} ${interview.lname || ''}`}</TableCell>
                              <TableCell>
                                 <p className={classes.positions}>
                                    {candidate && candidate.job_type_name.length > 0 ? candidate.job_type_name.join(', ') : ''}
                                 </p>
                              </TableCell>

                              <TableCell className={`row_status_${(item && item.interviewStatus) !== undefined ? statusObj[item.interviewStatus] : 'Booked'}`}>
                                 <b
                                    className={`status_interview status_${
                                       (item && item.interviewStatus) !== undefined ? statusObj[item.interviewStatus] : 'Booked'
                                    }`}
                                 ></b>{' '}
                                 {(item && item.interviewStatus) !== undefined ? statusObj[item.interviewStatus] : 'Booked'}
                              </TableCell>
                              <TableCell>
                                 <ActionButtons data={item} onStatus={handleOnStatus} onDelete={handleOnDelete} />
                              </TableCell>
                           </TableRow>
                        );
                     })
                  ) : (
                     <TableRow>
                        <TableCell component="th" scope="row" align="center" colSpan={7}>
                           Data not found
                        </TableCell>
                     </TableRow>
                  )}
               </TableBody>
            </Table>
         </TableContainer>
         {selectedData && <StatusModal data={selectedData} />}
         {scheduled_interview_list && scheduled_interview_list.length > 0 && (
            <div className="newsubs_pagination_right">
               {interviewData.totalCount > 0 && (
                  <div className="interview_pagination">
                     <Pagination
                        activePage={interviewData.activePage}
                        itemsCountPerPage={interviewData.limit}
                        totalItemsCount={interviewData.totalCount}
                        pageRangeDisplayed={5}
                        onChange={handlePageChange}
                        prevPageText={'Prev'}
                        nextPageText={'Next'}
                        firstPageText={'First'}
                        lastPageText={'Last'}
                     />
                  </div>
               )}
            </div>
         )}
         {deleteData && (
            <DeleteModal
               target={deleteData && deleteData.target}
               Id={deleteData && deleteData.id}
               onClose={handleOnDeleteConfirm}
               message="Are you sure you want to Delete?"
            />
         )}
      </>
   );
};

const mapStateToProps = ({ InterviewTableComponent }) => {
   return { InterviewTableComponent };
};

export default connect(mapStateToProps, {
   getScheduledInterviewData,
})(TableInterview);
